export const MAX_COUNT_OF_VISIBLE_PAGINATION_BUTTONS = 7;
export const COUNT_OF_SIBLINGS_VISIBLE_PAGINATION_BUTTONS = 2;
export const WHEN_DOTS_ARE_HIDDEN = 4;
